import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper, Stack } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFound = (): React.JSX.Element => {
  const navigate = useNavigate();

  const handleGoHome = (): void => {
    navigate('/');
  };

  const handleGoBack = (): void => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="60vh"
        textAlign="center"
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            borderRadius: 2,
            maxWidth: 500,
            width: '100%',
          }}
        >
          <Stack spacing={3} alignItems="center">
            <ErrorOutlineIcon
              sx={{
                fontSize: 80,
                color: 'warning.main',
                mb: 2,
              }}
            />

            <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: { xs: '4rem', md: '6rem' },
                fontWeight: 'bold',
                color: 'primary.main',
                lineHeight: 1,
              }}
            >
              404
            </Typography>

            <Typography
              variant="h4"
              component="h2"
              sx={{
                fontWeight: 'medium',
                color: 'text.primary',
                mb: 1,
              }}
            >
              Page Not Found
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Sorry, the page you're looking for doesn't exist or may have been moved.
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              alignItems="center"
            >
              <Button
                variant="contained"
                startIcon={<HomeIcon />}
                onClick={handleGoHome}
                size="large"
                sx={{ minWidth: 140 }}
              >
                Go Home
              </Button>

              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
                size="large"
                sx={{ minWidth: 140 }}
              >
                Go Back
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound;
